import { Component, OnDestroy, OnInit } from '@angular/core'
import { AbstractControl } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { MatSelectionListChange } from '@angular/material/list'
import { MatSelectChange } from '@angular/material/select'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { BehaviorSubject, Subscription } from 'rxjs'
import { AuthorizationService } from '../../../../access/shared/authorization/authorization.service'
import { Permissions } from '../../../../access/shared/authorization/permissions'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { Client } from '../../../shared/client/client'
import { Civility } from '../shared/civilite'
import { RoleHierarchy } from '../shared/role-hierarchi'
import { Site } from '../shared/site'
import { User } from '../shared/user'
import { UserForm } from '../shared/user-form'
import { UserService } from '../shared/user.service'
import { UserDialogComponent } from './user-dialog/user-dialog.component'

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit, OnDestroy {

  civilities: Array<Civility> = new Array<Civility>(
    { id: 1, libelle_long: "Monsieur" },
    { id: 2, libelle_long: "Madame" },
    { id: 3, libelle_long: "Mademoiselle" }
  )

  displayedColumns = ['site', 'client', 'action']

  private siteSub: Subscription = new Subscription()
  private groupSub: Subscription = new Subscription()
  private roleSub: Subscription = new Subscription()

  esclivaliableRoles: Array<RoleHierarchy> = new Array<RoleHierarchy>()
  sites: Array<Site> = new Array<Site>()
  siteFilter: BehaviorSubject<Site> = new BehaviorSubject<Site>(undefined)
  groupFilter: string = ""
  clientFilter: string = ""

  clients: Array<Client> = new Array<Client>()
  //interface with matTable
  matInterfaceSelected: MatTableDataSource<Client> = new MatTableDataSource<Client>()
  matInterface: MatTableDataSource<Client> = new MatTableDataSource<Client>()

  //current list selection
  selectedFilteredGroup: Array<Client> = new Array<Client>()

  formsControl: UserForm

  initRoles
  user: User

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private notification: NotificationService,
    private authorization: AuthorizationService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.formsControl = new UserForm()
    this.clients = new Array<Client>()
    this.formsControl.get('clients').valueChanges.subscribe((clients: Array<Client>) => {
      if (clients != null) {
        this.matInterfaceSelected.data = clients.sort((a: Client, b: Client) => {
          if (a != null && b != null) {
            return this.compareClient(a, b)
          }
          return 0
        })
        this.updateFilter()
      }
    })

    this.siteFilter.subscribe(site => {
      if (site !== undefined) {
        if (site.numero != "0") {
          this.groupSub = this.userService.getClients(site).subscribe(clients => {
            this.clients = clients.sort((a: Client, b: Client) => {
              if (a != null && b != null) {
                return this.compareClient(a, b)
              }
              return 0
            })
            this.updateFilter()
          })
        }
      }
    })


    this.route.data.subscribe(data => {
      this.user = data["user"]
      if (this.user != undefined) {
        this.formsControl.patchValue(this.user)
        this.onAnettChange(this.formsControl.get("is_anett").value)
        this.onDistriChange(this.formsControl.get("is_agent_distri").value)
        this.onAdminSiteChange(this.formsControl.get("is_admin_site").value)
        this.initRoles = this.formsControl.getRoles();
      } else if (this.isAdminDistri()) {
        this.formsControl.get('is_agent_distri').setValue(true)
      } else {
        this.formsControl.get('site_affectation').disable()
      }

    })

    this.roleSub = this.userService.getRoles().subscribe(roles => {
      this.esclivaliableRoles = roles.filter(ele => ele.name == Permissions.ROLE_CLIENT_EXT)[0].children
    })
    this.getSites()
  }

  getSites() {
    this.siteSub = this.userService.getSites().subscribe(sites => {
      // Suppression du site 0 (tous les sites) si pas agent distri
      if (!this.formsControl.value.is_agent_distri) {
        this.sites = sites.filter(site => site.numero != '0')
      } else {
        this.sites = sites.filter(site => site.is_on_hermine);
      }
      this.sites = this.sites.sort((a: Site, b: Site) => {
        if (a.numero > b.numero) return 1
        if (a.numero < b.numero) return -1
        else return 0
      })
      this.siteFilter.next(this.sites[0])
    })
  }

  selectClient(client: Client) {
    this.router.navigate(['../../profile/commande-settings', client.id], { relativeTo: this.route })
  }

  compareSite(a: Site, b: Site): boolean {
    return a != undefined && b != undefined && a.id === b.id
  }

  compareCivility(a: Civility, b: Civility): boolean {
    return a !== null && b != null && a.id === b.id
  }

  setSiteFilter($event: MatSelectChange) {
    this.siteFilter.next($event.value)
  }

  filterPredicate(client: Client, filter: string): boolean {
    return this.formsControl.filterPredicate(client, filter)
  }

  unselectGroup(client: Client) {
    this.formsControl.unselectGroup(client)
  }

  private compareClient(c: Client, c2: Client): number {
    if (c.site.numero != c2.site.numero) {
      if (c.site.numero < c2.site.numero) return -1
      else return 1
    } else {
      if (c.code_client > c2.code_client) return 1
      if (c.code_client < c2.code_client) return -1
    }
    return 0
  }

  selectGroup(client: Client) {
    this.formsControl.selectGroup(client)
  }

  isSelectedRole(role: RoleHierarchy): boolean {
    return this.formsControl.isSelectedRole(role)
  }

  isUserAdminSite(): boolean {
    return this.formsControl.isAdminSite()
  }


  private equalsRole(r: RoleHierarchy, or: RoleHierarchy): boolean {
    return this.formsControl.equalsRole(r, or)
  }

  selectionChange($event: MatSelectionListChange) {
    this.formsControl.updateRoles($event.options[0].value)
  }

  updateFilter() {
    this.matInterface.data = this.clients.filter(client => this.filterPredicate(client, this.groupFilter)).slice(0, 100)
  }

  isUserAnett(): boolean {
    return this.formsControl.isAnett()
  }

  isUserAgentDistri(): boolean {
    return this.formsControl.isAgentDistri()
  }

  submitForm() {
    if (this.formsControl.valid) {
      let user = this.formsControl.value
      if (this.user != undefined) user.id = this.user.id
      if (user.is_agent_distri == undefined) user.is_agent_distri = false
      if (user.is_anett == undefined) user.is_anett = false
      if (user.is_admin_site == undefined) user.is_admin_site = false
      let createForm = user.id == null
      this.userService.saveUser(user).subscribe(res => {
        if (createForm) {
          this.router.navigate(['/escli/users/list']).then(() => this.notification.notif("Le nouvel utilisateur a été crée", 'notif'))
        } else {
          this.notification.notif("Les modifications sont enregistrées", 'notif')
        }
        if (this.initRoles.length != this.formsControl.getRoles().length) {
          this.dialog.open(UserDialogComponent, {
            data: {
              username: this.username.value,
              email: this.email.value
            }
          })
        } else {
          this.initRoles.forEach(role => {
            if (!this.formsControl.getRoles().some(r => this.equalsRole(role, r))) {
              this.dialog.open(UserDialogComponent, {
                data: {
                  username: this.username.value,
                  email: this.email.value
                }
              })
              return
            }
          })
        }
        this.initRoles = this.formsControl.getRoles()
        this.router.navigate(['..'], { relativeTo: this.route })
      }, error => console.log(error));
    } else {
      if (this.formsControl.hasError('minElement', ['roles'])) {
        this.notification.notif("Vous devez choisir au moins un Role", 'error')
      } else if (this.formsControl.hasError('minElement', ['clients'])) {
        this.notification.notif("Vous devez choisir au moins un client pour un utilisateur externe", 'error')
      } else {
        this.notification.notif("Le formulaire n'est pas valide", 'error')
      }
    }
  }

  getErrorMessage(formControlName) {
    if (this.formsControl.get(formControlName).hasError('required')) {
      return "Cette valeur est requise"
    } else if (this.formsControl.get(formControlName).hasError('email')) {
      return "Cette adresse email n'est pas correct"
    }
  }

  get username(): AbstractControl {
    return this.formsControl.get("username")
  }

  get firstname(): AbstractControl {
    return this.formsControl.get("firstname")
  }

  get lastname(): AbstractControl {
    return this.formsControl.get("lastname")
  }

  get civility(): AbstractControl {
    return this.formsControl.get("civility")
  }

  get email(): AbstractControl {
    return this.formsControl.get("email")
  }

  get phone(): AbstractControl {
    return this.formsControl.get("phone")
  }

  get site_affectation(): AbstractControl {
    return this.formsControl.get("site_affectation")
  }

  ngOnDestroy() {
    this.siteSub.unsubscribe()
    this.roleSub.unsubscribe()
    this.groupSub.unsubscribe()
  }

  onAnettChange(checked) {
    if (!this.formsControl.value.is_agent_distri) {
      if (!checked) {
        this.formsControl.get('site_affectation').setValue(undefined)
        this.formsControl.get('is_admin_site').setValue(false)
        this.formsControl.get('site_affectation').disable()
        this.formsControl.get('is_agent_distri').enable()
      } else {
        this.formsControl.removeClients()
        this.formsControl.get('site_affectation').enable()
        this.formsControl.get('is_agent_distri').disable()
      }
      this.formsControl.updateClientsControl()
    }
  }

  onDistriChange(checked) {
    this.getSites()
    if (!this.formsControl.value.is_anett && !this.formsControl.value.is_admin_site) {
      if (checked) {
        this.formsControl.removeClients()
        this.formsControl.get('site_affectation').enable()
        this.formsControl.get('is_anett').disable()
        this.formsControl.get('is_admin_site').disable()
      } else {
        this.formsControl.get('site_affectation').setValue(undefined)
        this.formsControl.get('site_affectation').disable()
        this.formsControl.get('is_anett').enable()
        this.formsControl.get('is_admin_site').enable()
      }
    }
  }

  onAdminSiteChange(checked) {
    if (!this.formsControl.value.is_agent_distri) {
      if (!checked && !this.formsControl.value.is_anett) {
        this.formsControl.get('site_affectation').setValue(undefined)
        this.formsControl.get('site_affectation').disable()
        this.formsControl.get('is_agent_distri').enable()
      } else {
        this.formsControl.get('is_anett').setValue(true)
        this.formsControl.get('site_affectation').enable()
        this.formsControl.get('is_agent_distri').disable()
      }
    }
  }

  isAdminDistri() {
    return this.authorization.hasPermission(Permissions.ROLE_ADMIN_DISTRI)
  }
}
